import React, { useState, Fragment, useEffect } from "react";

import { useTranslation } from "react-i18next";

import { useNotification } from "@hooks/useNotification";
import { isEqual } from "lodash";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

import AddButton from "@components/buttons/AddButton";
import EmptyData from "@components/tailwindComponents/EmptyData";

import { OnboardingProtocol } from "@services/all.services";

import ModalTaskForm from "./modalTaskForm";
import ProtocolTaskItem from "./protocolTaskItem";

export default function ProtocolTaskList(props) {
  const [showModalCreateTask, setShowModalCreateTask] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [isOnDrag, setIsOnDrag] = useState(false);
  const { t } = useTranslation("beginEnd.protocol");
  const { showError, showSuccess } = useNotification();

  function toggleModalCreateTask() {
    setShowModalCreateTask((prevstate) => !prevstate);
  }

  useEffect(() => {
    if (!isEqual(taskList, props.protocol.tasks)) {
      setTaskList(props.protocol.tasks);
    }
  }, [props.protocol.tasks]);

  const handleDragEnd = (e) => {
    setIsOnDrag(false);
    if (!e.destination) return;
    let tempData = Array.from(taskList);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setTaskList(tempData);
    OnboardingProtocol.updateOrderProtocol(tempData)
      .then((result) => {
        if (result.success) {
          showSuccess("object_changed_success", { object: "order" });
        }
      })
      .catch(() => {
        showError("error");
      });
  };

  return (
    <>
      <div className="arh-flex arh-w-full arh-flex-col arh-pl-6">
        <div className="arh-mb-8 arh-mt-5 arh-flex arh-w-full arh-items-center">
          <AddButton
            label={t("Ajouter une tâche")}
            onClick={toggleModalCreateTask}
          />
        </div>

        <div className="arh-w-full ">
          <DragDropContext
            onDragEnd={handleDragEnd}
            onDragStart={() => setIsOnDrag(true)}
          >
            <table
              className={`arh-w-full arh-table-fixed arh-font-poppins ${
                isOnDrag && "arh-mb-12"
              }`}
            >
              <thead>
                <tr className="arh-bg-greyColor arh-text-left">
                  <th className="arh-w-[20%] arh-bg-greyColor arh-px-18 arh-py-2.5 arh-text-xs arh-font-semibold arh-text-darkColor">
                    {t("Tâches à réaliser")}
                  </th>
                  <th className="arh-w-[20%] arh-px-4 arh-text-xs arh-font-semibold arh-text-darkColor">
                    {t("Résultat attendu")}
                  </th>
                  <th className="arh-w-[50%] arh-px-4 arh-text-xs arh-font-semibold arh-text-darkColor">
                    {t("Détails/consignes")}
                  </th>
                  <th className="arh-w-[5%] arh-px-4"></th>
                  <th className="arh-w-[5%] arh-px-4"></th>
                </tr>
              </thead>

              <Droppable droppableId="droppable-1">
                {(provider) => (
                  <tbody
                    className="text-capitalize"
                    ref={provider.innerRef}
                    {...provider.droppableProps}
                  >
                    {taskList?.length ? (
                      taskList.map((task, index) => (
                        <ProtocolTaskItem
                          index={index}
                          key={task._id}
                          task={task}
                          taskList={taskList}
                        />
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5}>
                          <EmptyData>{t("Aucun élément")}</EmptyData>
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </Droppable>
            </table>
          </DragDropContext>
        </div>
      </div>

      {/* Modals */}
      <ModalTaskForm
        show={showModalCreateTask}
        fragment={Fragment}
        onClickClose={() => setShowModalCreateTask(false)}
        protocolId={props.protocol._id}
        taskList={taskList}
      />
      {/* End Modals */}
    </>
  );
}
